module.exports = "<app-course-details [course]=\"course\"></app-course-details>\n<app-course-details *ngIf=\"additionalCourse\" [course]=\"additionalCourse\"></app-course-details>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course-details-wrapper/course-details-wrapper.component.html
// module id = ./src/app/course-details-wrapper/course-details-wrapper.component.html
// module chunks = main